<template>
<v-row fill-height fluid class="mt-5 mx-1">
  <v-expansion-panels focusable>
    <v-expansion-panel
			:key="key"
			v-for="(courseType, key) in courseTypes"
      @click="getCourses(courseType)">
      <v-expansion-panel-header>
        {{ courseType.title }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-data-table v-model="selectedCourses" 
          show-select single-select 
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="filteredCourses"
          :loading="loading">
        </v-data-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</v-row>
</template>

<style>
  .v-expansion-panel-content__wrap {
    padding: unset;
  }

</style>

<script>
import { COURSE } from '../../services/constants'
import Api from '../../services/api'
import Notify from '../../services/notify'

export default {
		name: 'RegisterCourseSelector',
		data() {
			return {
				courses: [],
				courseTypes: [],
				selectedCourses: [],
				selectedCourseType: null,
				loading: false,
				headers: [
					{ text: 'Title', value: 'title', align: 'start' },
					{ text: 'Duration', value: 'duration' },
					{ text: 'Scholarship', value: 'subtitle', },
					{ text: 'Remarks', value: 'remarks', sortable: false },
				],
			}
		},
    computed: {
      filteredCourses() {
        return this.courses.filter((course) => {
          if(course.hidden == 1) {
            return false;
          }

          return true;
        });
      }
    },
		watch: {
			selectedCourses(selectedCourses) {
				let remarks = null;
				selectedCourses.forEach(course => {
					if(!course.available) {
						remarks = course.remarks || 'Course unavailable';
					}
				});
				
				if(remarks) {
					this.selectedCourses = [];
					Notify.toast(remarks, 'error');
				}


				switch(this.selectedCourseType.id) {
					case COURSE.DIPLOMA: // DB:Diploma Programs
						if(selectedCourses.length > 2) {
							this.selectedCourses = selectedCourses.splice(2, selectedCourses.length);
						}
					break;
					case COURSE.SHORT_TERM: // DB:Short Term
						if(selectedCourses.length > 1) {
							this.selectedCourses = selectedCourses.splice(1, selectedCourses.length);
						}
					break;
				}

				this.$emit('course-selected', {
						courseType: this.selectedCourseType, 
						courses: this.selectedCourses
					});
			}
		},
		mounted() {
			this.refresh();
		},
		methods: {
			refresh() {
				this.loading = true;
				Api.course.getAllTypes().then((response) => {
					this.courseTypes = response.data.reverse();
					this.getCourses(this.courseTypes[0]);
				});
			},
			
			getCourses(courseType) {
				this.selectedCourses = [];
				this.selectedCourseType = courseType;

				let queryApi = Api.course.getAll;
				if(courseType) {	
					queryApi = Api.course.getAllFromType;
				}
				
				let courseTypeId = courseType.id || null;
				queryApi(courseTypeId).then((response) => {
					this.courses = response.data;
				})
				.catch(() => {
						this.courses = [];
				})
				.finally(() => this.loading = false);
			},
		}
}
</script>